import React, { useState, useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'

const MIN_SECONDS = 5

export function LiveSvgExportModal ({ isOpen, onClose, onConfirm, exporting }) {
  const [intervalSec, setIntervalSec] = useState('10')
  const [error, setError] = useState(null)
  const modalRef = useRef(null)

  useEffect(() => {
    if (isOpen) {
      setIntervalSec('10')
      setError(null)
    }
  }, [isOpen])

  useEffect(() => {
    if (!isOpen) return
    function handleOutside (e) {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        onClose()
      }
    }
    document.addEventListener('mousedown', handleOutside)
    return () => document.removeEventListener('mousedown', handleOutside)
  }, [isOpen, onClose])

  if (!isOpen) return null

  function handleSubmit (e) {
    e.preventDefault()
    const n = parseInt(String(intervalSec).trim(), 10)
    if (!Number.isFinite(n) || n < MIN_SECONDS) {
      setError(`Enter an integer of at least ${MIN_SECONDS} seconds.`)
      return
    }
    setError(null)
    onConfirm(n)
  }

  return createPortal(
    <div className='live-svg-export-backdrop' role='presentation'>
      <div
        className='live-svg-export-modal'
        ref={modalRef}
        role='dialog'
        aria-labelledby='live-svg-export-title'
        aria-modal='true'
      >
        <h2 id='live-svg-export-title' className='live-svg-export-title'>
          Export live SVG
        </h2>
        <div className='live-svg-export-caveats'>
          <p><strong>Demo only.</strong> This exports an SVG that polls the voting summary page for updates. It works for this URL only and will not reflect editor/canvas mapping changes. This is not a production pattern.</p>
        </div>
        <form onSubmit={handleSubmit}>
          <label className='live-svg-export-label' htmlFor='live-svg-poll-interval'>
            How frequently should the SVG update? (in seconds)
          </label>
          <input
            id='live-svg-poll-interval'
            type='number'
            min={MIN_SECONDS}
            step={1}
            className='live-svg-export-input'
            value={intervalSec}
            onChange={(ev) => setIntervalSec(ev.target.value)}
            disabled={exporting}
          />
          {/* <p className='live-svg-export-hint'>Minimum {MIN_SECONDS} seconds between refresh requests.</p> */}
          {error ? <p className='live-svg-export-error' role='alert'>{error}</p> : null}
          <div className='live-svg-export-actions'>
            <button type='button' className='live-svg-export-btn secondary' onClick={onClose} disabled={exporting}>
              Cancel
            </button>
            <button type='submit' className='live-svg-export-btn primary' disabled={exporting}>
              {exporting ? 'Exporting…' : 'Download SVG'}
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  )
}
